<ng-container *ngFor="let item of filterItems; trackBy: trackByFn; let i = index">
    <div class="cdp-filter-item">
        <hc-label class="cdp-filter-item-label">
            <span>{{ item.label }}</span>
            <span *ngIf="item.tooltip">
                <span class="icon-info cdp-info-ico cdp-info-ico-right" [hcTooltip]="item.tooltip"></span>
            </span>
        </hc-label>
        <ng-container [ngSwitch]="item.filterType">
            <cdp-multi-select
                *ngSwitchCase="'multi-select'"
                class="filter-item-padding"
                [selections]="item.selections"
                [items]="item.items"
                [placeholder]="item.placeholder ? item.placeholder : ''"
                [tooltip]="item.tooltip"
                [loading]="item.loading"
                [controlName]="item.formControlName"
                [bindLabel]="item.bindLabel"
                (selectionChange)="selectionChange.emit($event)"
            ></cdp-multi-select>
            <cdp-single-select
                *ngSwitchCase="'single-select'"
                class="filter-item-padding"
                [selection]="item.selections"
                [items]="item.items"
                [placeholder]="item.placeholder ? item.placeholder : ''"
                [tooltip]="item.tooltip"
                [controlName]="item.formControlName"
                [bindLabel]="item.bindLabel"
                (selectionChange)="selectionChange.emit($event)"
            ></cdp-single-select>
            <cdp-yes-no-select
                *ngSwitchCase="'yes-no'"
                class="filter-item-padding"
                [selection]="item.selections"
                [placeholder]="item.placeholder ? item.placeholder : ''"
                [tooltip]="item.tooltip"
                [controlName]="item.formControlName"
                [bindLabel]="item.bindLabel"
                (selectionChange)="selectionChange.emit($event)"
            ></cdp-yes-no-select>
            <cdp-min-max
                *ngSwitchCase="'min-max'"
                [tooltip]="item.tooltip"
                [minSelection]="item.selectionMin!"
                [maxSelection]="item.selectionMax!"
                [controlName]="item.formControlName"
                (minSelectionChange)="selectionChange.emit($event)"
                (maxSelectionChange)="selectionChange.emit($event)"
            ></cdp-min-max>
            <cdp-date-picker
                *ngSwitchCase="'date-picker'"
                style="padding-bottom: 0"
                [tooltip]="item.tooltip"
                [minDateSelection]="item.dateMin!"
                [maxDateSelection]="item.dateMax!"
                [controlName]="item.formControlName"
                (minDateSelectionChange)="selectionChange.emit($event)"
                (maxDateSelectionChange)="selectionChange.emit($event)"
            ></cdp-date-picker>
        </ng-container>
    </div>
</ng-container>
